import React from "react";
import {IGridConfigItem} from "../../../../constants/interfaces";

type Props = {
    item: IGridConfigItem,
    updateConfig: Function
}

const ShowCircles = (props: Props) => {
    return (
        <div className="config-item__show-circles mb-2 mt-2">
            <label className="control control-checkbox"
                   htmlFor={`checkbox-${props.item.cell_id}`}>
                <input type="checkbox"
                       id={`checkbox-${props.item.cell_id}`}
                       onChange={() => props.updateConfig(['show_circles'], [props.item.show_circles === 1 ? 0 : 1])}
                       value="show_circles"
                       checked={!!props.item.show_circles}
                />
                <div className="control-indicator"></div>
                Show notification circles
            </label>
        </div>
    );
};

export default ShowCircles;
// gojko
